import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { IconButton } from '@mui/material';
import styles from './styles';

const ShowPassword = (props: any) => {
  const classes = styles();

  return (
    <IconButton onClick={props.onClick} className={classes.IconContainer}>
      {props?.showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
    </IconButton>
  );
};

export default ShowPassword;
